var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"mt-10",attrs:{"cols":"8"}},[_c('v-alert',{attrs:{"border":"bottom","colored-border":"","type":"warning","elevation":"2"}},[_vm._v("Hi there, polite notice. Your account is inactive. Please activate or contact administrator")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }